export default "__VITE_ASSET__BxyTmfW9__"